import * as CryptoJS from 'crypto-js';


const AES_KEY = '0123456789abcdef';

export function Encrypt(value?: string): string {

    if (!value?.trim()) {
        return '';
    }

    try {
        return CryptoJS.AES.encrypt(value, AES_KEY).toString();
    } catch (error) {
        console.error('Error al encriptar:', error);
        return '';
    }

}

export function Decrypt(value?: string): string {

    if (!value?.trim()) {
        return '';
    }

    try {
        const bytes = CryptoJS.AES.decrypt(value, AES_KEY);
        return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
        console.error('Error al desencriptar:', error);
        return '';
    }

}

export function detectBrowserName(): string {

    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes('edg')) {
        return 'edge';
    }

    if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
        return 'chrome';
    }

    if (userAgent.includes('firefox')) {
        return 'firefox';
    }

    if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
        return 'safari';
    }

    if (userAgent.includes('opera') || userAgent.includes('opr')) {
        return 'opera';
    }

    if (userAgent.includes('msie') || userAgent.includes('trident')) {
        return 'msie';
    }

    return 'unknown';

}

const FORMAS_PAGO = new Map<string, string>([
    ['01', 'Efectivo'],
    ['02', 'Cheque nominativo'],
    ['03', 'Transferencia electrónica de fondos'],
    ['04', 'Tarjeta de crédito'],
    ['05', 'Monedero electrónico'],
    ['06', 'Dinero electrónico'],
    ['08', 'Vales de despensa'],
    ['12', 'Dación en pago'],
    ['13', 'Pago por subrogación'],
    ['14', 'Pago por consignación'],
    ['15', 'Condonación'],
    ['17', 'Compensación'],
    ['23', 'Novación'],
    ['24', 'Confusión'],
    ['25', 'Remisión de deuda'],
    ['26', 'Prescripción o caducidad'],
    ['27', 'A satisfacción del acreedor'],
    ['28', 'Tarjeta de débito'],
    ['29', 'Tarjeta de servicios'],
    ['30', 'Aplicación de anticipos'],
    ['99', 'Por definir']
]);
export function formaspago(clave?: string): string {

    if (!clave?.trim()) {
        return '';
    }

    const normalizedKey = clave.trim();
    const descripcion = FORMAS_PAGO.get(normalizedKey);

    return descripcion
        ? `${normalizedKey} - ${descripcion}`
        : '';

}

export function tipoComprobante(texto:string) {
    let array = {
        'tipocom': [
            { 'clave': 'I', 'description': 'Ingreso' },
            { 'clave': 'E', 'description': 'Egreso' },
            { 'clave': 'T', 'description': 'Traslado' },
            { 'clave': 'N', 'description': 'Nómina' },
            { 'clave': 'P', 'description': 'Pago' },
        ]
    }
    let type = array.tipocom.filter(el => el.clave === texto);
    let typeuse = type[0];
    let textcfdi = `${typeuse['clave']} - ${typeuse['description']}`;
    return textcfdi;
}

export function regimenFiscal(texto:string) {
    let array = {
        'regimen': [
            { 'clave': '601', 'description': 'General de Ley Personas Morales' },
            { 'clave': '603', 'description': 'Personas Morales con Fines no Lucrativos' },
            { 'clave': '605', 'description': 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
            { 'clave': '606', 'description': 'Arrendamiento' },
            { 'clave': '607', 'description': 'Régimen de Enajenación o Adquisición de Bienes' },
            { 'clave': '608', 'description': 'Demás ingresos' },
            { 'clave': '609', 'description': 'Consolidación' },
            { 'clave': '610', 'description': 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
            { 'clave': '611', 'description': 'Ingresos por Dividendos (socios y accionistas)' },
            { 'clave': '612', 'description': 'Personas Físicas con Actividades Empresariales y Profesionales' },
            { 'clave': '614', 'description': 'Ingresos por intereses' },
            { 'clave': '615', 'description': 'Régimen de los ingresos por obtención de premios' },
            { 'clave': '616', 'description': 'Sin obligaciones fiscales' },
            { 'clave': '620', 'description': 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
            { 'clave': '621', 'description': 'Incorporación Fiscal' },
            { 'clave': '622', 'description': 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
            { 'clave': '623', 'description': 'Opcional para Grupos de Sociedades' },
            { 'clave': '624', 'description': 'Coordinados' },
            { 'clave': '625', 'description': 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
            { 'clave': '626', 'description': 'Régimen Simplificado de Confianza' },
            { 'clave': '628', 'description': 'Hidrocarburos' },
            { 'clave': '629', 'description': 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales' },
            { 'clave': '630', 'description': 'Enajenación de acciones en bolsa de valores' },
        ]
    };
    let type = array.regimen.filter(el => el.clave === texto);
    let typeuse = type[0];
    let textcfdi = `${typeuse['clave']} - ${typeuse['description']}`;
    return textcfdi;
}

export function filteruseCfdi(tipo:string) {

    let array = {
        'usecfdi': [
            { 'clave': 'G01', 'description': 'Adquisición de mercancías' },
            { 'clave': 'G02', 'description': 'Devoluciones, descuentos o bonificaciones ' },
            { 'clave': 'G03', 'description': 'Gastos en general ' },
            { 'clave': 'I01', 'description': 'Construcciones ' },
            { 'clave': 'I02', 'description': 'Mobiliario y equipo de oficina por inversiones ' },
            { 'clave': 'I03', 'description': 'Equipo de transporte ' },
            { 'clave': 'I04', 'description': 'Equipo de cómputo y accesorios ' },
            { 'clave': 'I05', 'description': 'Dados, troqueles, moldes, matrices y herramental ' },
            { 'clave': 'I06', 'description': 'Comunicaciones telefónicas ' },
            { 'clave': 'I07', 'description': 'Comunicaciones satelitales ' },
            { 'clave': 'I08', 'description': 'Otra maquinaria y equipo ' },
            { 'clave': 'D01', 'description': 'Honorarios médicos, dentales y gastos hospitalarios. ' },
            { 'clave': 'D02', 'description': 'Gastos médicos por incapacidad o discapacidad ' },
            { 'clave': 'D03', 'description': 'Gastos funerales. ' },
            { 'clave': 'D04', 'description': 'Donativos' },
            { 'clave': 'D05', 'description': 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación). ' },
            { 'clave': 'D06', 'description': 'Aportaciones voluntarias al SAR. ' },
            { 'clave': 'D07', 'description': 'Primas por seguros de gastos médicos. ' },
            { 'clave': 'D08', 'description': 'Gastos de transportación escolar obligatoria. ' },
            { 'clave': 'D09', 'description': 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones. ' },
            { 'clave': 'D10', 'description': 'Pagos por servicios educativos (colegiaturas) ' },
            { 'clave': 'P01', 'description': 'Por definir ' }
        ]

    };
    let type = array.usecfdi.filter(el => el.clave === tipo);
    let typeuse = type[0];
    // 
    let textcfdi = `${typeuse['clave']} - ${typeuse['description']}`;
    return textcfdi;
}

export function metodospago(texto:string) {

    let array = {
        'usecfdi': [
            { 'clave': 'PPD', 'description': 'Pago en Parcialidades o Diferido' },
            { 'clave': 'PUE', 'description': 'Pago en Una sola Exhibición' },

        ]

    };
    let type = array.usecfdi.filter(el => el.clave === texto);
    let typeuse = type[0];
    // 
    let textcfdi = `${typeuse['clave']} - ${typeuse['description']}`;
    return textcfdi;
}


export function obtenerMes(numero:string) {
    var meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

    var numeroMes = parseInt(numero);
    let datos;

    if (!isNaN(numeroMes) && numeroMes >= 1 && numeroMes <= 12) {

        datos = meses[numeroMes - 1];


    }
    return datos;

}


export function compararMeses(data:any) {


    let meses = [
        { id: '1', mes: "Enero" },
        { id: '2', mes: "Febrero" },
        { id: '3', mes: "Marzo" },
        { id: '4', mes: "Abril" },
        { id: '5', mes: "Mayo" },
        { id: '6', mes: "Junio" },
        { id: '7', mes: "Julio" },
        { id: '8', mes: "Agosto" },
        { id: '9', mes: "Septiembre" },
        { id: '10', mes: "Octubre" },
        { id: '11', mes: "Noviembre" },
        { id: '12', mes: "Diciembre" }
    ]

    var data3 = data.filter(function(el:any) {
        var found = false,
            x = 0;
        while (x < meses.length && !found) {
            if (el.id == meses[x].id && el.mes == meses[x].mes) found = true;
            x++;
        }
        if (!found) return el;
    });

    // añadimos todas las cadenas del segundo array que no estén en el primero
    data3 = data3.concat(meses.filter(function(el) {
        var found = false,
            x = 0;
        while (x < data.length && !found) {
            if (el.id == data[x].id && el.mes == data[x].mes) found = true;
            x++;
        }
        if (!found) return el;
    }));


    return data3;

}



export function setting_process_data(
    data: any,
    key: string,
    defaultValue: any = null
): any {

    if (!Array.isArray(data) || !key) {
        return defaultValue;
    }

    const setting = data.find(item => item.key_value === key);

    if (!setting) {
        return defaultValue;
    }

    switch (setting.value) {
        case 'true':
            return true;

        case 'false':
            return false;

        default:
            return setting.value;
    }
}

const MESES = new Map<string, number>([
    ['ENERO', 1],
    ['FEBRERO', 2],
    ['MARZO', 3],
    ['ABRIL', 4],
    ['MAYO', 5],
    ['JUNIO', 6],
    ['JULIO', 7],
    ['AGOSTO', 8],
    ['SEPTIEMBRE', 9],
    ['OCTUBRE', 10],
    ['NOVIEMBRE', 11],
    ['DICIEMBRE', 12]
]);

export function validarMeses(texto?: string): number {

    if (!texto?.trim()) {
        return 0;
    }

    return MESES.get(texto.trim().toUpperCase()) ?? 0;

}